const avatar = {
  width: 180,
  height: 180,
}

const project = {
  main: {
    width: 1440,
    height: 1080,
  },
  width: 1080,
  height: 1080,
}

const company = {
  logo: {
    width: 960,
    height: 540,
  }
}

const identification = {
  width: 540,
  height: 540,
}

const quality = 0.75;

export default {
  avatar,
  project,
  quality,
  company,
  identification,
}